var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopycode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1667 6.6665H8.83332C7.91285 6.6665 7.16666 7.4127 7.16666 8.33317V16.6665C7.16666 17.587 7.91285 18.3332 8.83332 18.3332H17.1667C18.0871 18.3332 18.8333 17.587 18.8333 16.6665V8.33317C18.8333 7.4127 18.0871 6.6665 17.1667 6.6665Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83332 13.3332C2.91666 13.3332 2.16666 12.5832 2.16666 11.6665V3.33317C2.16666 2.4165 2.91666 1.6665 3.83332 1.6665H12.1667C13.0833 1.6665 13.8333 2.4165 13.8333 3.33317",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopycode);
export default __webpack_public_path__ + "static/media/copycode.84be4b401223f6c03d8f5042f05a420f.svg";
export { ForwardRef as ReactComponent };